// @flow

import React from 'react';
import {Link} from 'react-router';
import cs from 'classnames';
import styled from 'styled-components';

import {
  withTypedRouter,
  type WithRouterProps,
} from 'app/general/withTypedRouter';
import {colors} from 'js-libs/sweetcommons/styles';
import {
  useNavLinks,
  isNavLinkActive,
} from 'app/general/structures/SPFrame/SPHeader/nav_links';

const StyledNavigationListUl = styled.ul.attrs({
  className: 'list-unstyled',
})`
  > li {
    > a {
      display: block;
      margin: 0;
      padding: 1rem 15px;
      border-bottom: 1px solid ${colors.mediumGreen};
      transition: all 250ms;
      border-left: 3px solid rgba(0, 0, 0, 0);
      text-decoration: none;

      > i {
        margin-right: 10px;
      }

      > span {
        color: #fff;
      }

      &.small {
        padding: 0.75rem 15px;
      }

      &:hover,
      &.active {
        background: ${colors.mediumGreen};
        border-left-color: ${colors.lightLinkBlue};

        i {
          color: ${colors.lightLinkBlue};
        }
      }
    }
  }
`;

type RouterProps = WithRouterProps<>;

type OwnProps = {|
  onToggle: () => any,
|};
type Props = {|
  ...OwnProps,
  ...RouterProps,
|};

export const NavigationList = withTypedRouter<OwnProps, RouterProps>(
  ({onToggle, routes}: Props) => {
    const navLinks = useNavLinks();
    return (
      <div>
        <StyledNavigationListUl>
          {navLinks.map((link) => (
            <li key={link.slug}>
              <Link
                className={cs({
                  small: !link.isMain,
                  active: isNavLinkActive(link.slug, routes),
                })}
                key={link.slug}
                to={link.href}
                onClick={onToggle}
              >
                <i className={`fa fa-fw fa-${link.icon}`} />
                <span>{link.title}</span>
              </Link>
            </li>
          ))}
        </StyledNavigationListUl>
      </div>
    );
  }
);
